import React, { useMemo } from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { Histogram } from "@ant-design/plots";

const RealizedGainHistogram = (props) => {
  const { signals } = props.optionsResults;

  const data = useMemo(
    () =>
      signals
        .filter((s) => s.success)
        .map((s) => ({ value: s.hitDayReturn })),
    [signals]
  );

  const config = {
    data,
    style: { inset: 0.5 },
    binField: "value",
    channel: "count",
    binWidth: 0.5,
  };

  return (
    <GenericCard
      title="Realized gain on hits"
      tooltipText="Distribution of the actual close-to-close gain on the day a signal hit target -- since a hit is only confirmed after target is crossed, the realized gain is often higher than the target itself. Shows how much upside is typically left on the table if you sell right at target vs. what the close actually printed."
      maxHeight={500}
      isCardOpenByDefault={false}
      className="table-card"
    >
      <Histogram {...config} height={350} autoFit={false} />
    </GenericCard>
  );
};

RealizedGainHistogram.propTypes = { optionsResults: PropTypes.object };

export default RealizedGainHistogram;
